import tinycolor from 'tinycolor2'
import Vue from 'vue'

Vue.use({
  install (Vue) {
    Vue.prototype.$tinycolor = tinycolor
  },
})



// WEBPACK FOOTER //
// ./src/server/plugins/tinycolor.js